import { RydeAdminUnit, RydeUiUnit } from "../models";

export type EntityAdminPathKeys = keyof typeof entityPathMappingsAdmin;

export const isEntityAdminPathMapped = (
  entity: RydeUiUnit,
): entity is RydeAdminUnit => {
  return entityPathMappingsAdmin[entity as EntityAdminPathKeys] !== undefined;
};

export const entityPathMappingsAdmin: Record<
  RydeAdminUnit | "unknown",
  string
> = {
  adminAction: "adminActions",
  adminTools: "tools",
  alertConfiguration: "alert-configuration",
  apiKey: "apiKeys",
  auditLog: "auditLogs",
  backup: "backupManagement",
  process: "processes",
  busStation: "busStations",
  mapCacheStat: "mapCacheStat",
  company: "companies",
  customField: "custom_fields",
  entity: "entities",
  etlJobLog: "etlJobLogs",
  etlSchedule: "etlSchedules",
  fieldType: "field_types",
  formSchema: "form_schemas",
  globalConfig: "global_configs",
  gridSchema: "grid_schemas",
  language: "language",
  messagingLog: "messagingLogs",
  permission: "permissions",
  aiConversation: "aiConversations",
  providerLog: "providerLogs",
  report: "reportManagement",
  role: "roles",
  supplierQuarantine: "supplierQuarantines",
  unknown: "",
  user: "users",
  userRole: "user_roles",
  webhook: "webhooks",
  webhookDelivery: "webhookLogs",
  geoArea: "geoAreas",
} as const;
